import React from 'react'
import { Layout } from 'antd'; 
import Start from './start/Start'
import Qiaomu from './qiaomu/Qiaomu'
import Guanmu from './guanmu/Guanmu'
import Model from './model/Model'
import Contact from './contact/Contact'
import Widget from './widget/Widget'
import Lineroad from './lineroad/Lineroad'
import Specialroad from './specialroad/Specialroad'
import Crossroad from './crossroad/Crossroad'
import Roadtex from './roadtex/Roadtex'
import Landscapeadd from './landscapeadd/Landscapeadd'
import Landscapeop from './landscapeop/Landscapeop'
import Weather from './weather/Weather'
import Terr from './terr/Terr'
import Light from './light/Light'
import Effec from './effec/Effec'
import { Route, Routes, Navigate } from 'react-router-dom'
import BottomFooter from '../bottomfooter/BottomFooter';
const { Content } = Layout;

export default function Contents() {
    return (
        <Content style={{
            overflow: 'auto',
            height: '100vh',
            width: '100vw',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            paddingTop:70,
            paddingLeft:200,
          }}>
            <Layout style={{
           paddingLeft:20,
          }}>
            <Routes>
                <Route path="/content/start" element={<Start />} />
                <Route path="/content/model/qiaomu" element={<Qiaomu />} />
                <Route path="/content/model/guanmu" element={<Guanmu />} />
                <Route path="/content/model/model" element={<Model />} />
                <Route path="/content/contact" element={<Contact />} />
                <Route path="/content/widget" element={<Widget />} />
                <Route path="/content/roadmodel/lineroad" element={<Lineroad />} />
                <Route path="/content/roadmodel/specialroad" element={<Specialroad />} />
                <Route path="/content/roadmodel/crossroad" element={<Crossroad />} />
                <Route path="/content/roadtex" element={<Roadtex />} />
                <Route path="/content/landscape/add" element={<Landscapeadd />} />
                <Route path="/content/landscape/operate" element={<Landscapeop />} />
                <Route path="/content/envir/weather" element={<Weather />} />
                <Route path="/content/envir/terr" element={<Terr />} />
                <Route path="/content/envir/light" element={<Light />} />
                <Route path="/content/envir/effec" element={<Effec />} />
                <Route path="*" element={<Navigate to="/content/start" />} />
            </Routes>
            </Layout>
            <Layout>
            <BottomFooter></BottomFooter>
            </Layout>
        </Content>
    )
}
